import { Map as ImmutableMap, Record } from 'immutable';
import { CLOSE_CONFIRM_DIALOG, TOGGLE_CONFIRM_DIALOG } from './constants';

const InitialState = Record({
  display: new ImmutableMap({ default: false }),
});

const initialState = new InitialState();

function reducer(state = initialState, action = undefined) {
  switch (action.type) {
    case TOGGLE_CONFIRM_DIALOG: {
      const { id } = action.payload;
      return state.setIn(['display', id], !state.getIn(['display', id]));
    }
    case CLOSE_CONFIRM_DIALOG: {
      const { id } = action.payload;
      return state.setIn(['display', id], false);
    }
    default:
      return state;
  }
}

export default reducer;
